import { Box, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useGetLastPayout } from "@src/appV2/redesign/Accounts/PayoutSettings/api/useGetLastPayout";
import { useHistory } from "react-router-dom";

import { FAILED_PAYOUT_FULL_PATH } from "../paths";
import { FailedPayoutBanner } from "./FailedPayoutBanner";

export interface FailedPayoutBannerContainerProps {
  sourceUI: "shifts-tab" | "bookings-tab" | "account-tab" | "earnings-page";
  sx?: SxProps<Theme>;
}

export function FailedPayoutBannerContainer(props: FailedPayoutBannerContainerProps) {
  const { sourceUI, sx } = props;

  const history = useHistory();

  const isBannerEnabled = useCbhFlag(CbhFeatureFlag.ENABLE_FAILED_PAYOUT_BANNER, {
    defaultValue: false,
  });
  const lastPayout = useGetLastPayout({
    enabled: isBannerEnabled,
  });

  const isBannerShown =
    isBannerEnabled &&
    lastPayout.data?.data.attributes.status === "failed" &&
    lastPayout.data.data.attributes.amount > 0;

  useLogEffect(
    APP_V2_USER_EVENTS.FAILED_PAYOUT_BANNER_SHOWN,
    {
      sourceUI,
      amount: lastPayout.data?.data.attributes.amount,
      errorCode:
        lastPayout.data?.data.attributes.status === "failed"
          ? lastPayout.data.data.attributes.errorCode
          : undefined,
      errorMessage:
        lastPayout.data?.data.attributes.status === "failed"
          ? lastPayout.data.data.attributes.errorMessage
          : undefined,
    },
    { enabled: isBannerShown }
  );

  if (!isBannerShown) {
    return null;
  }

  return (
    <Box sx={sx}>
      <FailedPayoutBanner
        payoutAmount={lastPayout.data?.data.attributes.amount ?? 0}
        onClick={() => {
          history.push(FAILED_PAYOUT_FULL_PATH);
        }}
      />
    </Box>
  );
}
